class ImageBanner extends HTMLDivElement {

  constructor() {
    super();

    this.init();
  }

  elements = {
    video: this.querySelector('video') || false,
  }

  events = {
    handleClick: (e) => {

      if ( !e.srcElement.classList.contains('banner__content') ) return;

      if ( this.elements.video.paused ) {
        this.elements.video.play();
        this.classList.add('video-playing');
        return;
      }
      
      this.elements.video.pause();
      this.classList.remove('video-playing');
    }
  }

  init() {
    
    if ( this.elements.video && this.elements.video.paused === false ) {
      setTimeout( () => {
        this.classList.add('video-playing');
      }, 1500)
    }

    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener('click', this.events.handleClick )
  }
}

customElements.define('image-banner', ImageBanner, { extends: "div" });